import { NextSeo } from "next-seo";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Container, Grid, Box, Image } from "theme-ui";
import { Themed } from "@theme-ui/mdx";

const TeamMember = ({ name, title, image, children }) => (
  <Box sx={{ textAlign: "center" }}>
    <Image
      sx={{ mx: "auto", mb: "sm" }}
      src={image}
      variant="circle"
      alt={`Portrait of ${name}`}
    />
    <Themed.h2 sx={{ mb: 0 }}>{name}</Themed.h2>
    <Themed.h3>{title}</Themed.h3>
    {children}
  </Box>
);

const TheTeam = () => (
  <>
    <NextSeo title="Treats Children Charity Derby | Meet the team" />
    <Container variant="page">
      <Header />
      <main>
        <Container variant="muted">
          <Themed.h1 sx={{ textAlign: "center", m: 0 }}>
            Meet the team
          </Themed.h1>
        </Container>
        <Container>
          <Grid gap="lg" columns={[1, null, 2]}>
            <TeamMember
              name="Elaine Blount"
              title="Founder Member"
              image="/elaine-blount.webp"
            >
              <Themed.p>
                I have been a member of Treats for over 35 years, and am so
                proud of what Treats has achieved since starting the charity all
                those years ago. We were a small group of Derbyshire Mums
                wanting to give something back to our community, specifically
                children, and this remains the aim of Treats to this day.
              </Themed.p>
              <Themed.p>
                Derby is home to my husband John and I, and we have recently
                celebrated our 55th Wedding Anniversary. We have 3 children, 9
                grandchildren and a great grandchild joining the family in 2022.
                Derby has been very good to our family over the years and it is
                a privilege to be able to give back to children who just need a
                little happiness in their lives.
              </Themed.p>
            </TeamMember>
            <TeamMember name="Vicky Ashton" title="Chair" image="/vicky.webp">
              <Themed.p>
                I was delighted to join my Mum (Elaine Blount) as a committee
                member of Treats over 25 years ago. Treats is and has always
                been an honour and a pleasure to be a part of. It gives me so
                much pride on how many children we have helped over the years.
                My husband and I have raised our family in Derby. Our three
                children were toddlers when I joined Treats, and all are now
                adults - how the time has flown by!
              </Themed.p>
              <Themed.p>
                As a family we are all very privileged to help in any way we can
                those less fortunate than ourselves.
              </Themed.p>
            </TeamMember>
            <TeamMember name="Joanne Taylor" image="/jo-taylor.webp">
              <Themed.p>
                I can hardly believe it&apos;s been over 25 years since I joined
                Treats.
              </Themed.p>
              <Themed.p>
                I am very very proud of the Charity, what it has achieved over
                the years, and how it has evolved with the times. The great
                generosity and kindness of Derby people has helped make our jobs
                easier, and enabled us to give so many wonderful treats to
                children in the Derbyshire area.
              </Themed.p>
              <Themed.p>
                I am Derby born and bred and have been married to my husband
                Stephen for over 30 years. We have three wonderful children who
                have gone on with their lives and met wonderful partners
                themselves. We also have three amazing grandchildren.
              </Themed.p>
              <Themed.p>
                I am still so passionate about the charity and the work we do.
                May it continue for many more years
              </Themed.p>
            </TeamMember>
            <TeamMember name="Candy Sutton" image="/candy.webp">
              <Themed.p>
                Hi, my name is Candy, (which is short for Catherine!)
              </Themed.p>
              <Themed.p>
                I have been on the Treats committee for over 24 years, serving
                as Treasurer for over ten years. I work in Derby and have lived
                here all my life. I am passionate about bringing joy and treats
                to underprivileged and deserving children in the Derbyshire
                area.
              </Themed.p>
              <Themed.p>
                At home, I love spending time with my family and friends, my
                gorgeous Labrador Harvey, and my ducks, chickens and garden!
              </Themed.p>
            </TeamMember>
            <TeamMember
              name="Julie Ellis-Walford"
              image="/julie-ellis-walford.webp"
            >
              <Themed.p>
                Derby born and bred, I have been part of the Treats Committee
                for over 25 years, and I’ve loved every minute of it! The shared
                passion and enthusiasm of the Treats team brings us together as
                life long friends, with a shared pride in the support we deliver
                to the children of Derbyshire.
              </Themed.p>
              <Themed.p>
                In my spare time I love walking, entertaining, gardening, and
                cooking (not baking though, I’m really not very good at that!)
              </Themed.p>
            </TeamMember>
            <TeamMember
              name="Tracey Coupland-Smith"
              image="/tracey-coupland-smith.webp"
            >
              <Themed.p>
                I joined Treats in January 2013, and love how the group get
                along and all get stuck in when there’s a job to be done.
              </Themed.p>
              <Themed.p>
                The annual Christmas Treats programme in particular is very
                close to my heart. It's hard work, incredibly humbling, but such
                a great feeling when we're dropping the children’s presents off
                to schools ready for Santa.
              </Themed.p>
              <Themed.p>
                Me and my husband Anthony, moved from Ilkeston to Derby when our
                three children were young. Our children are adults now but we
                have a new ‘toddler’ running around our home - our cocker
                spaniel Teddie! He keeps us on our toes and is a much loved
                addition to our family.
              </Themed.p>
            </TeamMember>
            <TeamMember name="Kate Theaker" image="/kate-theaker.webp">
              <Themed.p>
                I met the Treats Committee and found out more about their great
                work and results over 10 years ago, and have been a member ever
                since.
              </Themed.p>
              <Themed.p>
                I love spending time with the Treats team organising our
                fundraising, and feel so proud of what we do to help make some
                of Derbyshire childrens’ lives a little better.
              </Themed.p>
              <Themed.p>
                When I’m not working at our Derby based family business, I love
                spending my time with my family - especially my four gorgeous
                grandchildren.
              </Themed.p>
              <Themed.p>
                Cooking and in particular baking and making celebration cakes is
                also something I love to do.
              </Themed.p>
            </TeamMember>
            <TeamMember name="Teddie" image="teddie.webp">
              My name is Teddie and my role is to look cute and distract the
              Treats Committee during their meetings, which I am very good at!
            </TeamMember>
          </Grid>
        </Container>
        <Container
          variant="muted"
          sx={{ textAlign: "center", fontStyle: "italic" }}
        >
          <Grid gap="lg" columns={[1, null, 3]}>
            <Box>
              "Your hard work and generosity, makes a massive difference to our
              families. The gifts were received with such excitement and
              gratitude!""
            </Box>
            <Box>
              "We have broken up now and as I sit reflecting on a difficult last
              year, I just want to say, to the donors, sponsors, volunteers and
              organisers at Treats...Thank you, thank you!"
            </Box>
            <Box>
              "The joy on the children&apos;s faces when they receive the
              &apos;treats&apos; from Treats Children's Charity is so difficult
              to put into words."
            </Box>
          </Grid>
        </Container>
      </main>
    </Container>
    <Footer />
  </>
);

export default TheTeam;
